import Vue from "vue";

Vue.filter("capitalize", function (value) {
	if (!value) return "";
	value = value.toString();
	return value.toUpperCase();
});

Vue.filter("removePytorchExtention", function (value) {
	console.log({value});
	if (!value.includes(".pytorch")) return value

	return value.replace(".pytorch", "");
});